import SearchParsingCars from './SearchParsingCars';

export default SearchParsingCars;